module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_vm._v("Preface")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Take cover!” Major Warren screamed as echoes of AK-47 ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("and small arms fire rung out across the field.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The Marines hit the ground as bullets rained down on their position from an indeterminate location. Sergeant ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Juarez and the unit’s Iraqi translator, Fahdi, dropped to the ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ground, but it was too late. Before Fahdi’s knees hit the ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("grass, he was struck with a searing pain in his chest and was knocked back several feet. In an instant, he was flat on his back staring up at the crystalline blue sky. It felt like ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("he’d been hit by a truck. The air was sucked out of his ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("lungs and he gasped to catch his breath. Sergeant Juarez ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("threw his body protectively over Fahdi’s attempting to ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("shield him from further wounds, but as Juarez’s weight fell ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("on top of Fahdi it made it even more difficult for Fahdi to ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("get the air he desperately needed back into his lungs.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Once Fahdi finally caught his breath, he noticed the ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("blood. “I’ve been shot!” he screamed. “Get off me!” Fahdi ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("struggled to push the massive Marine Sergeant off him. ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Fahdi was wearing body armor but from the pain he was in ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("and the blood he saw he was sure the bullet had gone through it.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("“Stay the fuck down!” Sergeant Juarez yelled back. ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("“I’m hit! It went through!” Fahdi continued to yell")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" a")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("nd squirm under Juarez’s weight. Due to the immense ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("pain and trouble he was having to breathe, Fahdi feared the bullet had struck one of his lungs.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Sergeant Juarez sat up and straddled Fahdi, holding ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("him down so he could survey the damage. “Where are you ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("hit?” he yelled.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("“My chest!” Fahdi blurted. Blood was smeared all ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("over the front of Fahdi’s uniform and across his body ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("armor. “Oh fuck! Oh fuck! I’m bleeding bad!” He was in a lot of pain but actually relieved because he knew the pain meant he probably wasn’t dying. Sergeant Juarez ripped ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("the Velcro straps from Fahdi’s bullet proof vest and ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("pushed the armor up over his head. He ran his hands up ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("and down Fahdi’s chest and stomach and across his ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("shoulders.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("“There’s nothing! It didn’t go through. You’re fine.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("But I’m bleeding!” Fahdi argued.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("“No, you’re not. I am,” Juarez replied in a surprisingly calm tone.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Fahdi looked and saw Sergeant Juarez’s uniform near the top corner of his right shoulder was ripped. Blood ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("was seeping from the area and dripping down his arm. ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("He’d been grazed by a round, perhaps the same one that ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("took Fahdi down. When he’d thrown his body over Fahdi’s, ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("he bled onto him, covering Fahdi in more blood than himself. “Shit dude, you’re hit!” Fahdi said, now shifting his focus from his own injuries to Sergeant Juarez’s ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("shoulder wound. “We’ve gotta’ get you to a medic.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("“It’s fine. It looks worse than it really is. I only got ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("grazed,” Juarez said as he grabbed Fahdi’s vest and looked ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("at it. His finger found the indentation where the AK-47 ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("round that took Fahdi down was embedded deep into one of the vest’s chest plates. “See,” he said pointing it out to ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Fahdi, “the bullet that got you is right here. Put your vest ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("back on, we’ve got to catch back up with the Major.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Fahdi pulled the body armor vest back over his ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("head and strapped it on")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v(".")]), _c('span', {
    staticClass: "ital"
  }), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("He glanced down and noticed the ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("bullet was lodged in the area right over his heart.")]), _c('span', {
    staticClass: "CharOverride-3"
  }), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Holy fuck! I’d have been dead")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-781770bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VoicingtheEagle24.vue
// module id = 69
// module chunks = 0